export const MODULE_NAME = 'views/cottage-list'

export const ITEMS_PER_PAGE = 20
